module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-27.6b29493d.png";